<template>
  <v-content>
    <main-toolbar />
    <main-drawer />
    <router-view />
    <change-password-dialog />
    <trocar-empresa-dialog />
  </v-content>
</template>

<script>
import MainToolbar from "../components/MainToolbar";
import MainDrawer from "../components/MainDrawer";
import ChangePasswordDialog from "../components/ChangePasswordDialog";
import TrocarEmpresaDialog from "../components/TrocarEmpresaDialog";
export default {
  components: {
    MainToolbar,
    MainDrawer,
    ChangePasswordDialog,
    TrocarEmpresaDialog
  }
};
</script>
